<!-- 払い戻し確認 -->
<template>
  <TemplateMfittMyTicketRefundConfirmation />
</template>

<script>
import TemplateMfittMyTicketRefundConfirmation from "@/views/Templates/MFITT/TemplateMfittMyTicketRefundConfirmation";
import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "MfittMyTicketRefundConfirmation",
  components: {
    TemplateMfittMyTicketRefundConfirmation,
  },
  setup() {},
};
</script>
